import { useState, useEffect, useCallback } from "react";
import { useRecoilState } from "recoil";
import { navStepAtom, productKeyAtom } from "src/atoms";
import { setProductToSessionStorage } from "src/utils/storage/auth";
import useEmblaCarousel from "embla-carousel-react";
import { useRouter } from "src/hooks/useRouter";
import { ProductKey } from "src/config/config";
import { useQueryClient } from "react-query";
import "./index.style.scss";
import useProductInfo, {
  isDspProductList,
  productSlugMap,
} from "src/mocks/useProductInfo";
import SwiperBtn from "src/assets/images/swiper_btn.svg"; // 최상단 import
import { useSearchParams } from "react-router-dom";
import { useIsOciProduct } from "src/hooks/recoil/useIsOciProduct";
const ProductSwiper = () => {
  const [productKey, setProductKey] = useRecoilState(productKeyAtom);
  const [navStep, setNavStep] = useRecoilState(navStepAtom);
  // const [dspProduct, setDspProduct] = useRecoilState(dspProductAtom);
  const [canScrollPrev, setCanScrollPrev] = useState(false);
  const [canScrollNext, setCanScrollNext] = useState(false);
  const { currentPath, goSiteType, goConsole, goHome } = useRouter();
  const [searchParams, setSearchParams] = useSearchParams();
  // const { priceListRefetch } = usePriceList({});
  const { productOptions } = useProductInfo();
  const { isOciProduct } = useIsOciProduct();
  const queryClient = useQueryClient();

  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
    dragFree: true,
    slidesToScroll: 1,
  });

  const [selectedIndex, setSelectedIndex] = useState(0);
  // URL 파라미터에서 product 추출하여 setProductKey에 반영
  useEffect(() => {
    // const searchParams = new URLSearchParams(window.location.search);
    // const productParam = searchParams.get("product");
    const productParam = productSlugMap[searchParams.get("product") || ""];
    if (
      productParam &&
      productOptions.some((opt) => opt.value === productParam)
    ) {
      const index = productOptions.findIndex(
        (opt) => opt.value === productParam
      );
      onProductSelect(productParam as ProductKey, index);
      console.log("productParam", productParam);
    }
  }, []);

  const updateScrollButtons = useCallback(() => {
    if (!emblaApi) return;
    setCanScrollPrev(emblaApi.canScrollPrev());
    setCanScrollNext(emblaApi.canScrollNext());
  }, [emblaApi]);
  // 현재 선택된 제품의 인덱스 찾기
  useEffect(() => {
    if (productKey) {
      const currentProductIndex = productOptions.findIndex(
        (option) => option.value === productKey
      );
      if (currentProductIndex !== -1) {
        setSelectedIndex(currentProductIndex);
      }
    }
  }, [productKey]);

  // embla API가 준비되면 선택된 슬라이드로 스크롤
  useEffect(() => {
    if (emblaApi && selectedIndex >= 0) {
      emblaApi.scrollTo(selectedIndex);
    }
  }, [emblaApi, selectedIndex]);

  const onProductSelect = async (product: ProductKey, index: number) => {
    setSelectedIndex(index);
    if (isDspProductList.includes(product)) {
      setProductToSessionStorage("DSP");
      setProductKey(product as ProductKey);
      // setDspProduct(product);
    } else {
      setProductToSessionStorage(product);
      setProductKey(product);
      // setDspProduct(product);
    }
    // priceListRefetch();
    queryClient.clear();

    // if (["DSPM", "FIRESIDE", "DSP"].includes(product)) {
    //   await checkProductAvailable({
    //     product: product,
    //   }).then((isAvailable) => {
    //     console.log("isAvailable", product, isAvailable);
    //     if (isAvailable) {
    //       setNavStep(3);
    //       goConsole();
    //     }
    //   });
    // } else if (["WRAPSODY", "WRAPSODY_ECO"].includes(product)) {
    //   if (currentPath.includes("/site/pay")) goSiteType();
    //   if (currentPath.includes("/site/promotion")) goSiteType();
    //   if (currentPath.includes("/console")) {
    //     await checkProductAvailable({
    //       product: product,
    //     }).then((isAvailable) => {
    //       if (isAvailable) goConsole();
    //       else goSiteType();
    //     });
    //   } else {
    //     goConsole();
    //   }
    // }
  };

  const scrollPrev = useCallback(() => {
    if (emblaApi) emblaApi.scrollPrev();
  }, [emblaApi]);

  const scrollNext = useCallback(() => {
    if (emblaApi) emblaApi.scrollNext();
  }, [emblaApi]);
  useEffect(() => {
    if (!emblaApi) return;

    updateScrollButtons();
    emblaApi.on("select", updateScrollButtons);
    emblaApi.on("reInit", updateScrollButtons);
  }, [emblaApi, updateScrollButtons]);
  if (!productKey) return null;

  // 로그인, 회원가입 페이지에서만 표시됨
  const visiblePage = ["/login", "/join"];
  const shouldRender = visiblePage.some((path) => currentPath.includes(path));
  if (!shouldRender || isOciProduct) return null;
  return (
    <div className="product-swiper">
      <div className="product-swiper__viewport" ref={emblaRef}>
        {canScrollPrev && (
          <>
            {/* <div className="product-swiper__blur2 product-swiper__blur--prev2" /> */}
            <div className="product-swiper__blur product-swiper__blur--prev" />
          </>
        )}
        {canScrollNext && (
          <div className="product-swiper__blur product-swiper__blur--next" />
        )}
        <div className="product-swiper__container">
          {productOptions.map((option, index) => {
            const isSelected = selectedIndex === index;
            return (
              <div
                key={option.value}
                className={`product-swiper__slide ${
                  isSelected ? "selected" : ""
                }`}
                onClick={() => {
                  // DSP 제품은 DSP로 통합
                  // const product = isDspProductList.includes(option.value)
                  //   ? "DSP"
                  //   : option.value;

                  // onProductSelect(product as ProductKey, index);
                  onProductSelect(option.value as ProductKey, index);
                }}
              >
                <div
                  className={`product-card ${
                    isSelected ? "" : "cursor-pointer"
                  }`}
                >
                  <div className="product-card__icon">
                    <img src={option.icon} alt={option.label} />
                    {/* <i className={option.icon} /> */}
                  </div>
                  <div className="product-card__content">
                    <h3 className={`product-card__title`}>
                      {/* {option.value === "FED" ? (
                        <div>
                          <div>PC 문서 보안</div>
                          (FED-N)
                        </div>
                      ) : (
                        <>{option.label}</>
                      )} */}
                      {option.label}
                    </h3>
                    {/* <p className="product-card__description">
                    {option.description}
                  </p> */}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      <div className="product-swiper__controls">
        <button
          className={`product-swiper__button product-swiper__button--prev`}
          style={{
            visibility: canScrollPrev ? "visible" : "hidden",
          }}
          onClick={scrollPrev}
          aria-label="이전 제품"
        >
          <img src={SwiperBtn} alt="이전 제품" />
        </button>
        <button
          className={`product-swiper__button product-swiper__button--next`}
          style={{
            visibility: canScrollNext ? "visible" : "hidden",
          }}
          onClick={scrollNext}
          aria-label="다음 제품"
        >
          <img src={SwiperBtn} alt="다음 제품" />
        </button>
      </div>
    </div>
  );
};

export default ProductSwiper;
